import { Injectable, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";

export interface IToastItem {
  delay: number;
  level: number;
  text: string;
}

@Injectable({
    providedIn: "root"
})
export class ToastService {
    trigger: Subject<IToastItem> = new Subject<IToastItem>();

    private readonly translate = inject(TranslateService);

    add(text: string, level = 1, delay = 3000) {
        const translatedText = this.translate.instant(text);
        this.trigger.next({
            text: translatedText,
            delay: delay,
            level: level
        });
    }
}
